
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppProperties } from '../model/application-properties';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable({
    providedIn: 'root',
})

export class ApiLoadService {

    appIntialURL: string;

    constructor(private http: HttpClient) { }


    getBackendApi() {

        this.appIntialURL = window.location.origin + '/fetchAppProperties';
        return this.http.get<AppProperties>(this.appIntialURL);
    }
}
